import React, { ReactElement } from 'react'
import Tile from '../General/Tile/Tile'
import styles from './GallonsGrid.module.scss';
import { useLifetimeLocationGallonsQuery } from '../../generated/graphql'
import gql from 'graphql-tag'
import Badge from '../General/Badge/Badge';

export const LocationGallonsQuery = gql`
    query LifetimeLocationGallons($locationKey: Int!) {
        lifetimeGallons(locationKey: $locationKey) {
            year
            jan
            feb
            mar
            apr
            may
            jun
            jul
            aug
            sep
            oct
            nov
            dec
        }
    }
`

interface Props {
    locationKey: number,
    isActiveLocation: boolean
}

export default function LocationGallonGrid(props: Props): ReactElement {
    const { data, loading, error } = useLifetimeLocationGallonsQuery({ variables: { locationKey: props.locationKey } })

    if (loading || error) {
        return <div></div>
    }

    if (data && data.lifetimeGallons == null) {
        return props.isActiveLocation ?
            <Tile title="Gallons Purchased">
                <Badge textColor="#155724" backgroundColor="#D4EDDA">Active Location</Badge>
            </Tile> :
            <Tile title="Gallons Purchased">
                <Badge textColor="#D77328" backgroundColor="#F2E6DD">Inactive Location</Badge>
            </Tile>
    }

    const formatNum = (gallons: number) => {
        return gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    let rows = []

    data.lifetimeGallons.forEach((x, index) => {
        const row = (
            <div className="row" key={index}>
                <div className="col">{x.year}</div>
                <div className="col">{formatNum(x.jan)}</div>
                <div className="col">{formatNum(x.feb)}</div>
                <div className="col">{formatNum(x.mar)}</div>
                <div className="col">{formatNum(x.apr)}</div>
                <div className="col">{formatNum(x.may)}</div>
                <div className="col">{formatNum(x.jun)}</div>
                <div className="col">{formatNum(x.jul)}</div>
                <div className="col">{formatNum(x.aug)}</div>
                <div className="col">{formatNum(x.sep)}</div>
                <div className="col">{formatNum(x.oct)}</div>
                <div className="col">{formatNum(x.nov)}</div>
                <div className="col">{formatNum(x.dec)}</div>
            </div>
        )
        rows.push(row)
    })

    return <Tile title="Gallons Purchased">
        <div className={styles.gallonsGrid__smallText}>
            <div className="row" key="Header">
                <div className="col">Year</div>
                <div className="col">Jan</div>
                <div className="col">Feb</div>
                <div className="col">Mar</div>
                <div className="col">Apr</div>
                <div className="col">May</div>
                <div className="col">Jun</div>
                <div className="col">Jul</div>
                <div className="col">Aug</div>
                <div className="col">Sep</div>
                <div className="col">Oct</div>
                <div className="col">Nov</div>
                <div className="col">Dec</div>
            </div>
            {rows}
        </div>
    </Tile>
}